module.exports = __webpack_public_path__ + "static/media/Fahd.5733045c.jpeg";